import { OrganizationStatus } from "./enumerations/organization-status";
import i18n from "../i18n";

export const OrganizationStatusLabel = {
    [OrganizationStatus.Active]: i18n.t('general.orgStatus.active'),
    [OrganizationStatus.Expired]: i18n.t('general.orgStatus.expired'),
    [OrganizationStatus.Deactivated]: i18n.t('general.orgStatus.deactivated'),
}
